export * from './Avatar';
export { default } from './Avatar';
//# sourceMappingURL=index.js.map